<div app-landing-page-section-container class="items-center pb-5 lg:pb-10">
    <div class="mat-headline-6 text-center pb-4">
        <translate>Frequently Asked Questions</translate>
    </div>

    <div class="lg:w-[900px]">
        <app-accordion toggleBehavior="openIndependently">
            @for (question of faqs; track $index) {
                <app-collapsible
                    [title]="question + '-question-key' | translate"
                    [id]="question"
                >
                    <span [translate]="question + '-answer-key'"></span>
                </app-collapsible>
            }
        </app-accordion>
    </div>
</div>
